$(document).ready(function () {
   //filter popup faq sec
  $(".filter_accordion .filter_d_box:first-child .filter_d_heading")
    .addClass("active")
    .siblings(".filter_d_content")
    .slideDown();
  $("body").on("click", ".filter_d_heading", function () {
    $(this).next().slideToggle();
    $(this).toggleClass("active");
  });

  //filter popup open/close
  $('body').on('click', '.filter_sort_btn', function () {
    $('.filter_drower, body').addClass('active_drower');
  });

  $('body').on('click', '.filter_drower_over, .close_icon', function () {
    $('.filter_drower, body').removeClass('active_drower');
  });
  
  function get_data(searchParams) {
    var section_id = $('[data-filter-url]').attr('data-id');
    var url = `${window.location.pathname}?section_id=${section_id}&${searchParams}`;
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    $.get(url, function(data) {
      var html = $(data).find('[data-collection]').html();
      $('[data-collection]').html(html);
      $('[data-filter-price-box]').html($(data).find('[data-filter-price-box]').html());
      $('[data-filter-box]').each(function(p, q) {
        $(q, '[data-index="'+p+'"]').html($(data).find('[data-filter-box][data-index="'+p+'"]').html());
      })    
      
      var active_filter_html = $(data).find('[data-active-filter]').html();
      $('[data-active-filter]').html(active_filter_html);
      if ($('.filter_drower').hasClass('active_drower')) {
        $('.filter_drower_wrap .close_icon').click();
      }
    });
  }
  $('body').on('click','.submit_filter .filter_results',function() {
    var section_id = $('[data-filter-url]').attr('data-id');
    var form = $('#FacetFiltersForm')[0];
    var searchParams = new URLSearchParams(new FormData(form)).toString();
    get_data(searchParams);
  });
  
  $('body').on('click','.submit_filter .reset_filters ,.product_slider_wpr .reset_filters', function() {
    var url = $(this).attr('data-href').indexOf('?') == -1 ? '' : $(this).attr('data-href').slice($(this).attr('data-href').indexOf('?') + 1);
    get_data(url);
  });
  
  $('body').on('click', '[data-remove]', function(e) {
    e.preventDefault();
    var url = $(this).attr('data-href').indexOf('?') == -1 ? '' : $(this).attr('data-href').slice($(this).attr('data-href').indexOf('?') + 1);
    get_data(url);
  });

  // price range silder
  document.addEventListener("input", e => {
    const rangevalue = document.querySelector(".slider-container .price-slider");
    const rangeInputvalue = document.querySelectorAll(".range-input input");
    const priceInputvalue = document.querySelectorAll(".price-input input");
    
    // Set the price gap
    let priceGap = 10;
    var maxvalue = parseInt($('[data-filter-price-box] .price-input input.max-input').attr('max'));
  
    // Handle input events on price input elements
    if (e.target.closest('.price-input input')) {
      let minp = parseFloat(priceInputvalue[0].value);
      let maxp = parseFloat(priceInputvalue[1].value);
      let diff = maxp - minp;
  
      if (minp < 0) {
        alert("minimum price cannot be less than 0");
        priceInputvalue[0].value = 0;
        minp = 0;
      }
  
      if (maxp > maxvalue) {
        alert("maximum price cannot be greater than 10000");
        priceInputvalue[1].value = maxvalue;
        maxp = maxvalue;
      }
  
      if (minp > maxp - priceGap) {
        priceInputvalue[0].value = maxp - priceGap;
        minp = maxp - priceGap;
        if (minp < 0) {
          priceInputvalue[0].value = 0;
          minp = 0;
        }
      }
  
      if (diff >= priceGap && maxp <= rangeInputvalue[1].max) {
        if (e.target.className === "min-input") {
          rangeInputvalue[0].value = minp;
          let value1 = rangeInputvalue[0].max;
          rangevalue.style.left = `${(minp / value1) * 100}%`;
        } else {
          rangeInputvalue[1].value = maxp;
          let value2 = rangeInputvalue[1].max;
          rangevalue.style.right = `${100 - (maxp / value2) * 100}%`;
        }
      }
      var search_param = [];
      update_filter(search_param);
    }
  
    // Handle input events on range input elements
    if (e.target.closest('.range-input input')) {
      let minVal = parseFloat(rangeInputvalue[0].value);
      let maxVal = parseFloat(rangeInputvalue[1].value);
      let diff = maxVal - minVal;
  
      if (diff < priceGap) {
        if (e.target.className === "min-range") {
          rangeInputvalue[0].value = maxVal - priceGap;
        } else {
          rangeInputvalue[1].value = minVal + priceGap;
        }
      } else {
        priceInputvalue[0].value = minVal;
        priceInputvalue[1].value = maxVal;
        rangevalue.style.left = `${(minVal / rangeInputvalue[0].max) * 100}%`;
        rangevalue.style.right = `${100 - (maxVal / rangeInputvalue[1].max) * 100}%`;
      }
      var search_param = [];
      update_filter(search_param);
    }
  });
  //  infinite scrolling function start 
  var scroll = false;
  function ScrollExecute() {
   if($('.showing_results').height() + 800 < ($(document).scrollTop() + $(window).height())) {
    var scrollNode = $('.collection-loader');
    var scrollUrl = $('.collection-loader a.load_more').attr("href");
     if(!scroll && scrollNode.length > 0 && scrollUrl !== '') {
       $.ajax({
         type: 'GET',
         url: scrollUrl,
         beforeSend: function() {
           scroll = true;
           scrollNode.clone().empty().insertAfter(scrollNode).append('<div class="preloader"><img src="https://cdn.shopify.com/s/files/1/0574/9653/5155/files/ajax-loader.webp?v=1684314688" /></div>');
           scrollNode.empty();
           $('.collection-loader .load_more').empty();
         },
         success: function(data) {
           scrollNode.next().remove();
           var filteredData = $(data).find(".custom_scroll_wrap").html();
           var load_btn = $(data).find(".collection-loader").html();
           $(".custom_scroll_wrap").append(filteredData);
           $(".collection-loader").empty().html(load_btn);
           scroll = false;
         },
         dataType: "html"
       });
     }
   }
 }
 $(window).scroll(function(){
   setTimeout(function(){
    ScrollExecute();
   }, 100 );
 });
  //  infinite scrolling function end
  
  //  Read more button 
  $('body').on('click','.read_more',function(e){
    e.preventDefault();
     var text = $(this).text();
     if($(this).text() == 'Read More'){
       $(this).parents('.all_car_top_title').find('.read_div').show();
       $(this).text('Read Less');
     }else if($(this).text() == 'Read Less'){
       $(this).parents('.all_car_top_title').find('.read_div').hide();
       $(this).text('Read More');
     }
  });
  
  // collection page  slider
  function related_categories() {
    var swiper2 = new Swiper(".related_categories .r_categories_wpr", {
      slidesPerView: 1,
      draggable: true,
      loop: false,
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
      },
      navigation: {
        nextEl: ".sb_arrow_next",
        prevEl: ".sb_arrow_prev",
      },
      breakpoints: {
        1024: {
          slidesPerView: 3,
        },
        640: {
          slidesPerView: 2,
        },
      },
    });
  }
  related_categories();
  
  function s_collection() {
    var swiper = new Swiper(".slider_block_text:not(.without_sldier_block) .slider_block_wpr", {
      slidesPerView: 1,
      draggable: true,
      loop: false,
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
      },
      navigation: {
        nextEl: ".sb_arrow_next",
        prevEl: ".sb_arrow_prev",
      },
    });
  }
  s_collection();
});